import { render } from "./FormResourceMap.vue?vue&type=template&id=4e452d02"
import script from "./FormResourceMap.vue?vue&type=script&lang=js"
export * from "./FormResourceMap.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__